import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { ASPECT_COMPANY_FRAGMENT } from "./useAspects"

const BASE_GET_USER_RESELLER_ASPECTS = gql`
  query BaseGetUserResellerAspects($id: ID!, $perPage: Int!) {
    resellerAspects(id: $id, perPage: $perPage) {
      collection {
        id
        type
        company {
          ...AspectCompanyFragment
          customer {
            id
          }
        }
        authorizations {
          actions
        }
      }
    }
  }
  ${ASPECT_COMPANY_FRAGMENT}
`

export const useResellerAspects = ({
  variables: { id = "", perPage = 1 },
  ...options
}: {
  variables: { id?: string; perPage?: number }
  skip?: boolean
}) => {
  return useQuery(BASE_GET_USER_RESELLER_ASPECTS, {
    variables: { id, perPage },
    ignoredErrorCodes: ["403", "429"],
    ...options,
  })
}
